import { Link, LinkProps } from '../Link'

export const renderWithOptionalLink = (
  children: React.ReactNode,
  {
    href,
    as,
    external,
    target,
  }: {
    href?: LinkProps['href']
    as?: LinkProps['as']
    external?: LinkProps['external']
    target?: LinkProps['target']
  },
): React.ReactNode => {
  return href ? (
    <Link href={href} as={as} external={external} target={target}>
      {children}
    </Link>
  ) : (
    <>{children}</>
  )
}
